class GECKO_UTILS {
  static generateUniqueId() {
    return Math.floor(Math.random() * 0xffff).toString();
  }

  /*
   * For preparing class names
   * https://www.npmjs.com/package/classnames
   */

  static classNames() {
    var hasOwn = {}.hasOwnProperty;

    return (() => {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;

        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          classes.push(GECKO_UTILS.classNames.apply(null, arg));
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    })();
  }

  /**
   * Set a nested value on an object by a dot seperated key string, this will return a new instance of the object
   * @param {object} obj - The object you want to assign the value on
   * @param {string} key - A string of keys seperated by dots which target the value you want to set
   * @param {any} value  - The value you want to set
   * @return {object} - A new object instance with the nested value set
   */
  static setNestedValue(obj, key, value) {
    const [keyFragment, ...rest] = key.split('.');
    if (!rest.length) {
      return Object.assign({}, obj, { [keyFragment]: value });
    } else {
      return Object.assign({}, obj, {
        [keyFragment]: this.setNestedValue(
          obj[keyFragment],
          rest.join('.'),
          value
        ),
      });
    }
  }

  /**
   * Get a nested value on an object by a dot seperated key string.
   * @param {object} values - The object you want to get the nested value on
   * @param {string} key - The string of keys seperated by dots which target the value you want to get
   * @return {any} - The nested value
   */
  static getNestedValue(values, key) {
    const keyFragments = key.split('.');
    const getValue = (obj, key) => obj[key];
    return keyFragments.reduce(getValue, values);
  }

  /**
   *  Output error message from an array or object
   *  @param Errors string | array | object
   */

  static renderError(error) {
    var defaultMessage = 'Sorry, there was an error. Please try again.';

    if (typeof error === 'string' && error.length > 0) {
      return error;
    }

    if (error instanceof Array && error.length > 0) {
      return this.renderError(error[0]);
    }

    if (error instanceof Object && Object.keys(error).length > 0) {
      return this.renderError(error[Object.keys(error)[0]]);
    }

    return defaultMessage;
  }

  /**
   *  Get the contrasting color (black or white) for a provided hex code
   *  @param Hexcolor string
   */

  static getContrastColor(hexcolor) {
    if (!hexcolor) return 'white';
    hexcolor =
      hexcolor.indexOf('#') > -1 ? hexcolor.replace('#', '') : hexcolor;
    let r = parseInt(hexcolor.substr(0, 2), 16);
    let g = parseInt(hexcolor.substr(2, 2), 16);
    let b = parseInt(hexcolor.substr(4, 2), 16);
    let yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? '#1a252f' : 'white';
  }

  static prepareIndexClass(prefix, index) {
    if (index === undefined) return '';
    return `${prefix}-${index}`.replace(' ', '-').toLowerCase();
  }

  static prepareNameClass(prefix, name) {
    if (name === undefined) return '';
    return `${prefix}-${name}`
      .replace(' ', '-')
      .replace('.', '-')
      .toLowerCase();
  }
}

export default GECKO_UTILS;
